document.addEventListener("alpine:init", () => {
    Alpine.data("gallery", () => ({
        selectedItem: 0,
        show: false,
        items: [],
        dragging: false, // New flag to track dragging
        init() {
            console.log("[Gallery] Initialized");
            
            window.addEventListener("keydown", (e) => {
                if (e.key === "ArrowRight") {
                    console.log("[Gallery] ArrowRight pressed");
                    this.next();
                }
                if (e.key === "ArrowLeft") {
                    console.log("[Gallery] ArrowLeft pressed");
                    this.previous();
                }
            });

            this.initNav();
            this.initSwipe();
        },

        initNav() {
            const slider = this.$root.querySelector(".gallery-nav");
            let isDown = false;
            let startX;
            let startY;
            let scrollLeft;
            let dragThreshold = 5; // Minimum movement before dragging activates
        
            if (!slider) {
                console.warn("[Gallery] Slider element not found");
                return;
            }
        
            slider.addEventListener("mousedown", (e) => {
                isDown = true;
                this.dragging = false; // Reset dragging
                startX = e.pageX;
                startY = e.pageY;
                slider.classList.add("active");
                scrollLeft = slider.scrollLeft;
            });
        
            slider.addEventListener("mouseup", (e) => {
                isDown = false;
                slider.classList.remove("active");
                slider.classList.remove("scrolling");
        
                // Only prevent click if dragging actually happened
                if (!this.dragging) {
                    console.log("[Gallery] Click registered on thumbnail");
                    return;
                }
                console.log("[Gallery] Dragging detected, click blocked");
            });
        
            slider.addEventListener("mousemove", (e) => {
                if (!isDown) return;
        
                const moveX = Math.abs(e.pageX - startX);
                const moveY = Math.abs(e.pageY - startY);
        
                if (moveX > dragThreshold || moveY > dragThreshold) {
                    this.dragging = true; // Activate dragging mode only if movement exceeds threshold
                }
        
                if (this.dragging) {
                    slider.classList.add("scrolling");
                    e.preventDefault(); // Prevents click from firing
                    const x = e.pageX - startX;
                    slider.scrollLeft = scrollLeft - x;
                }
            });
        
            slider.addEventListener("mouseleave", () => {
                isDown = false;
                slider.classList.remove("active");
                slider.classList.remove("scrolling");
            });
        },

        initSwipe() {
            const container = this.$root;

            container.addEventListener("touchstart", (e) => {
                this.startX = e.touches[0].clientX;
            });

            container.addEventListener("touchend", (e) => {
                this.endX = e.changedTouches[0].clientX;
                this.handleSwipe();
            });
        },

        handleSwipe() {
            const diffX = this.endX - this.startX;

            if (diffX > 25) {
                this.previous(); // Swipe Right -> Previous Image
            } else if (diffX < -25) {
                this.next(); // Swipe Left -> Next Image
            }
        },

        close() {
            console.log("[Gallery] Closing gallery");
            this.pauseAllVideos();
            window.dispatchEvent(new CustomEvent("closegallery"));
        },

        download() {
            if (this.items[this.selectedItem]?.image) {
                const a = document.createElement("a");
                a.href = this.items[this.selectedItem].image.url;
                a.download = this.items[this.selectedItem].image.filename;
                console.log("[Gallery] Downloading image:", a.download);
                a.click();
            } else {
                console.warn("[Gallery] No image found for download");
            }
        },

        next() {
            console.log("[Gallery] Next clicked");
            if (this.selectedItem < this.items.length - 1) {
                console.log("[Gallery] Moving to next item:", this.selectedItem + 1);
                this.selectedItem++;
            } else {
                console.log("[Gallery] Reached end, looping back to 0");
                this.selectedItem = 0;
            }
            this.scrollIntoView();
        },

        previous() {
            console.log("[Gallery] Previous clicked");
            if (this.selectedItem > 0) {
                console.log("[Gallery] Moving to previous item:", this.selectedItem - 1);
                this.selectedItem--;
            } else {
                console.log("[Gallery] At start, looping to last item");
                this.selectedItem = this.items.length - 1;
            }
            this.scrollIntoView();
        },

        scrollIntoView() {
            const thumbnail = document.getElementById(`gallery-thumbnail-${this.selectedItem}`);
            if (!thumbnail) {
                console.warn("[Gallery] Thumbnail not found:", this.selectedItem);
                return;
            }
            const container = thumbnail.parentElement;
            const thumbnailRect = thumbnail.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();

            console.log("[Gallery] Scrolling into view:", this.selectedItem);

            if (thumbnailRect.left < containerRect.left) {
                const scrollBy = thumbnailRect.left - containerRect.left - 100;
                container.scrollBy({
                    left: scrollBy,
                    behavior: "smooth",
                });
            } else if (thumbnailRect.right > containerRect.right) {
                const scrollBy = thumbnailRect.right - containerRect.right + 100;
                container.scrollBy({
                    left: scrollBy,
                    behavior: "smooth",
                });
            }
        },

        selectItem(index) {
            console.log("[Gallery] Item clicked:", index, this.items[index]);

            if (this.dragging) {
                console.log("[Gallery] Click ignored due to dragging");
                return;
            }

            this.selectedItem = index;
            this.scrollIntoView();
        },

        isSelected(index) {
            return this.selectedItem === index;
        },

        isImage() {
            return (
                this.items.length &&
                this.items[this.selectedItem]?.media_type === "image" &&
                this.items[this.selectedItem]?.image
            );
        },

        initItems(items, startIndex = 0) {
            console.log("[Gallery] Initializing items:", items);

            if (items.filter((item) => item.media_type).length) {
                this.items = items.map((item) => {
                    if (item.media_type === "video_embed") {
                        const videoAttrs = this.extractAttributes(item.video_embed);
                        videoAttrs.src =
                            videoAttrs.src +
                            "&autoplay=1&mute=1&muted=1&loop=1&controls=1&playsinline=1&keyboard=false";
                        return { ...item, video: { ...videoAttrs } };
                    }
                    return item;
                });
            } else {
                this.items = items.map((item) => {
                    if (item.photo) {
                        return {
                            image: { ...item.photo },
                            media_type: "image",
                        };
                    }
                    return { image: { ...item }, media_type: "image" };
                });
            }

            setTimeout(() => {
                console.log("[Gallery] Selecting initial item:", startIndex);
                this.selectItem(startIndex);
            }, 1);
        },

        extractAttributes(htmlString) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(htmlString, "text/html");
            var iframe = doc.querySelector("iframe");
            var attrs = {};
            if (iframe) {
                Array.from(iframe.attributes).forEach((attr) => {
                    attrs[attr.name] = attr.value;
                });
            }
            console.log("[Gallery] Extracted iframe attributes:", attrs);
            return attrs;
        },

        pauseVideo(video, videoType) {
            console.log("[Gallery] Pausing video:", video, videoType);

            if (videoType === "upload") {
                video.pause();
                return;
            }

            if (videoType === "youtube") {
                const currentSrc = video.src.split("&");
                let newSrc = "";
                currentSrc.forEach((part) => {
                    if (part.includes("autoplay=")) {
                        part = "autoplay=0";
                    }
                    newSrc += part + "&";
                });
                video.src = newSrc;
            }

            if (videoType === "vimeo") {
                const player = new Vimeo.Player(video);
                player.pause();
            }
        },

        pauseAllVideos() {
            const mediaItems = document.querySelectorAll('[id^="media_item-"]');
            mediaItems.forEach((mediaItem) => {
                const video =
                    mediaItem.querySelector("video") ||
                    mediaItem.querySelector("iframe");
                if (video) {
                    const videoType = video.classList.contains("youtube")
                        ? "youtube"
                        : video.classList.contains("vimeo")
                            ? "vimeo"
                            : "upload";
                    this.pauseVideo(video, videoType);
                }
            });
        },
    }));
});
